import { TourBagMstrPayload } from '@/api/models';
import { Action, HeadTypeName } from '@/constants';

export type QueueType = 'TOUR_BAG';

export type OfflineQueuePayload = TourBagMstrPayload;

export default class OfflineQueueModel {
  id?: number;
  hasConflict = false;
  entityId: string;
  entityType: HeadTypeName;
  type: QueueType;
  action: Action;
  payload: OfflineQueuePayload;

  timestamp: number;

  retryCount = 0;
  lastAttempt?: number | null = null;

  meta?: Record<string, any>;

  error?: {
    error: string;
    code: number;
    timestamp: number;
    message: string;
    payload: any;
  };

  constructor(entityId: string, entityType: HeadTypeName, type: QueueType, action: Action, payload: OfflineQueuePayload) {
    this.entityId = entityId;
    this.entityType = entityType;
    this.type = type;
    this.action = action;
    this.payload = payload;
    this.timestamp = Date.now();
  }
}
